<template>
  <v-app class="position-relative">
    <div class="d-md-flex d-block login-form-wrapper" style="width: 100%">
      <div class="position-fixed top-0 left-0 w-100 h-100" style="z-index: 1; top: 0; left: 0;">
        <div id="login-slider-wrapper">
          <div id="promotion-login-slider">
            <div>
              <div class="image-slide position-fixed"
                :style="`background-image: url('/static/image/slider/${randomBackground}.jpg')`" />
            </div>
          </div>
        </div>
      </div>
      <div class="
          imagesContainer
          d-none d-md-flex
          align-content-center
          justify-content-center
          w-50
        ">
        <div class="introText-wraper" style="max-width: 100%; position: relative; z-index: 99">
          <div class="d-flex flex-column px-4 pb-3" style="color: white">
            <div class="d-flex flex-column align-items-center" style="font-size: 1.5rem">
              <img src="/logo/Gpuhub-logo-text-white.svg" style="height: 3.5rem" />
              <div style="font-size: 1rem; font-style: italic" class="mt-2">
                <!-- <img src="/logo/happy-rendering.svg" style="height: 24px;"> -->
                <h4>{{ $t('login.sloganLoginText') }}</h4>
              </div>
            </div>
            <div class="introText1 mt-3 d-flex justify-content-center">
              <div style="font-size: 1rem; font-weight: 600"
                v-html="$t('login.introText1')">
              </div>
            </div>
            <div v-if="change" style="text-align: center; font-size: 0.9rem" class="mb-1 mt-1"
                v-html="$t('login.introText3')">
                
            </div>
            <div v-else style="text-align: center; font-size: 0.9rem" class="mb-1 mt-1"
              v-html="$t('login.introText2')">
              
            </div>
          </div>
          <div class="d-flex flex-nowrap mt-3">
            <div class="w-50 mr-1 video-item">
              <div style="
                  width: 100%;
                  max-width: 100%;
                  padding-top: 50%;
                  position: relative;
                ">
                <iframe :src="youtybeEmbed1" frameborder="0" style="
                    z-index: 99;
                    border-radius: 5px;
                    position: absolute;
                    margin: auto;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                  " allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
              </div>
            </div>
            <div class="w-50 ml-1 video-item">
              <div style="
                  width: 100%;
                  max-width: 100%;
                  padding-top: 50%;
                  position: relative;
                ">
                <iframe :src="youtybeEmbed2" frameborder="0" style="
                    z-index: 99;
                    border-radius: 5px;
                    position: absolute;
                    margin: auto;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                  " allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <!-- <video autoplay="" muted="" loop="" playsinline="" style="width: 100%; border-radius: 12px; border:1px solid #444;">
              <source src="/img/logo_animate.mp4"
                type="video/mp4">
              Your browser does not support the video tag.
            </video> -->
            <img src="/img/logo_animate_optimized.gif" 
              style="width: 100%;height: auto;border-radius: 15px;background: rgba(0,0,0,0.5);"/>
          </div>
        </div>
      </div>
      <div class="
          componentContainer
          d-flex
          align-content-center
          justify-content-center
          align-items-center
          position-relative
        " style="z-index: 100">
        <component v-bind:is="mainComponent" @openComponentView="openComponentView" :location="location" />
      </div>
    </div>
  </v-app>
</template>

<script>
import baseComponent from "@/scripts/baseComponent";
import lazyLoadComponent from "@/scripts/lazyLoadComponent";
import SkeletonBox from "@/views/component/SkeletonBox";
import "bxslider/dist/jquery.bxslider.css";
import "bxslider/dist/jquery.bxslider.min.js";
import "@/assets/css/login.scss";
import "@/assets/responsive/login.scss";
import authApi from "@/api/auth";
const queryString = require("query-string");
const minBgIndex = 1;
const maxBgIndex = 6;
const VUE_APP_CODE = process.env.VUE_APP_CODE;
export default {
  extends: baseComponent,
  components: {},
  props: {},
  data: () => ({
    mainComponent: lazyLoadComponent({
      componentFactory: () => import("@/views/auth/component/Login"),
      loading: SkeletonBox,
    }),
    change: false,
    location: "",
  }),
  computed: {
    randomBackground() {
      let rndInt = Math.floor(Math.random() * maxBgIndex) + minBgIndex;
      try {
        let lastRandom = localStorage.getItem('randomBackground') || 1;
        let countLoop = 0;
        while (lastRandom === rndInt || (VUE_APP_CODE === 'IRENDER_GPU_VN' && rndInt === 3)) {
          rndInt = Math.floor(Math.random() * maxBgIndex) + minBgIndex;
          countLoop++;
          if (countLoop === 6) break;
        }
        localStorage.setItem('randomBackground', rndInt);
      } catch { }
      return rndInt;
    },
    youtybeEmbed1() {
      if (VUE_APP_CODE === 'IRENDER_GPU_VN') return 'https://www.youtube.com/embed/W7RqCsuA5tc';
      return 'https://www.youtube.com/embed/EuUroqBPANo';
    },
    youtybeEmbed2() {
      if (VUE_APP_CODE === 'IRENDER_GPU_VN') return 'https://www.youtube.com/embed/NaSa2RTicQI';
      return 'https://www.youtube.com/embed/6-LoVkQsy4w';
    }
  },
  mounted() {
    //let sliderPause = 6000;
    // $("#promotion-login-slider").bxSlider({
    //   mode: "fade",
    //   auto: true,
    //   pause: sliderPause,
    //   pager: false,
    //   randomStart: true,
    //   controls: false,
    // });

    // setInterval(() => {
    //   this.change = !this.change;
    // }, 15000);
  },
  created() {
    if (this.$route.name === "Register") {
      this.openComponentView("Register");
    }
    if (this.$route.name === "ForgotPassword") {
      this.openComponentView(this.$route.name);
    }
    this.getIpInfo();
  },
  methods: {
    openComponentView(componentName) {
      this.mainComponent = lazyLoadComponent({
        componentFactory: () =>
          import(`@/views/auth/component/${componentName}`),
        loading: SkeletonBox,
      });
      let urlParams = queryString.stringify(this.$route.query);

      if (componentName === "Register") {
        window.history.pushState("", "", `/register?${urlParams}`);
      }

      if (componentName === "ForgotPassword") {
        window.history.pushState("", "", "/forgot-password");
      }

      if (componentName === "Login") {
        window.history.pushState("", "", "/login");
      }
    },
    getIpInfo() {
      authApi
        .getIpInfo()
        .then((res) => {
          try {
            let data = res.data;
            if (data) {
              let ipDetails = JSON.parse(data);
              if (ipDetails.status === "success") {
                this.location = ipDetails.countryCode;
              }
            }
          } catch (error) {
            //this.$store.dispatch("common/showUnkownError", error, this.$lang.dialog.sendEmailFailed);
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("getIpInfo -> error", error);
        });
    },
  },
  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
    },
  },
};
</script>
